/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Signing_Sent_CreditsInputs */

const cs_signing_sent_credits = /** @type {(inputs: Signing_Sent_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dokument odeslán k podpisu (−${i?.credits} kreditů)`)
};

const en_signing_sent_credits = /** @type {(inputs: Signing_Sent_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Document sent for signing (−${i?.credits} credits)`)
};

/**
* | output |
* | --- |
* | "Document sent for signing (−{credits} credits)" |
*
* @param {Signing_Sent_CreditsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_sent_credits = /** @type {((inputs: Signing_Sent_CreditsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Sent_CreditsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_sent_credits(inputs)
	return cs_signing_sent_credits(inputs)
});